import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const ProofPage = lazy(() => import('../pages/proof/page'));
const FAQPage = lazy(() => import('../pages/faq/page'));
const LandingPageB = lazy(() => import('../pages/landing-page-b/page'));
const LandingPageC = lazy(() => import('../pages/landing-page-c/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/proof',
    element: <ProofPage />,
  },
  {
    path: '/faq',
    element: <FAQPage />,
  },
  {
    path: '/A13-1',
    element: <LandingPageB />,
  },
  {
    path: '/ERCM',
    element: <LandingPageC />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
